import styled from "styled-components";

export const Popup = styled.div`
  width: min(760px, calc(100vw - 48px));
  max-height: calc(100vh - 48px);
  padding: 32px 36px 28px;
  box-sizing: border-box;
  border-radius: 14px;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-shrink: 0;

  > .title {
    color: #121212;
    font-family: Pretendard;
    font-size: 28px;
    font-weight: 700;
  }

  > img {
    width: 17px;
    height: 17px;
    cursor: pointer;
  }
`;

export const Body = styled.div`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-right: 4px;
`;

export const Section = styled.div`
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const SectionTitle = styled.div`
  color: #121212;
  font-family: Pretendard;
  font-size: 18px;
  font-weight: 700;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  color: #121212;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 600;

  > .required {
    color: #ff4d4f;
  }
`;

export const TextInput = styled.input`
  width: 100%;
  height: 44px;
  padding: 0 14px;
  box-sizing: border-box;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  outline: none;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 500;
  color: #121212;

  &:focus {
    border-color: #7f25fb;
  }

  &:disabled {
    background: #f5f5f5;
    color: #969696;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 80px;
  padding: 12px 14px;
  box-sizing: border-box;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  outline: none;
  resize: vertical;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 500;
  color: #121212;

  &:focus {
    border-color: #7f25fb;
  }

  &:disabled {
    background: #f5f5f5;
    color: #969696;
  }
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

export const RadioOption = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 500;
  color: #121212;

  input[type="radio"] {
    appearance: none;
    width: 20px;
    height: 20px;
    border: 2px solid #d9d9d9;
    border-radius: 50%;
    margin: 0;
    cursor: pointer;
    flex-shrink: 0;
  }

  input[type="radio"]:checked {
    border: 5px solid #7f25fb;
    background: #fff;
  }

  input[type="radio"]:disabled {
    cursor: not-allowed;
  }
`;

export const DateRow = styled.div`
  display: flex;
  gap: 16px;

  > ${Field} {
    flex: 1;
  }
`;

export const SubText = styled.div`
  color: #969696;
  font-family: Pretendard;
  font-size: 12px;
  font-weight: 500;
`;

export const InfoBox = styled.div`
  padding: 14px 16px;
  border-radius: 8px;
  background: #f5f6f8;
  color: #666;
  font-family: Pretendard;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.6;
  white-space: pre-line;
`;

export const WarningBox = styled(InfoBox)`
  background: #fff8e6;
  color: #8a6d3b;
`;

export const ProgressOption = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ProgressSubText = styled.div`
  margin-left: 28px;
  color: #969696;
  font-family: Pretendard;
  font-size: 12px;
  font-weight: 500;
`;

export const RewardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const RewardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const AddRewardButton = styled.button`
  border: 1px solid #7f25fb;
  border-radius: 8px;
  background: #fff;
  color: #7f25fb;
  padding: 8px 14px;
  font-family: Pretendard;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const RewardCard = styled.div`
  border: 1px solid #ddd6fe;
  border-left: 4px solid #7f25fb;
  border-radius: 12px;
  padding: 18px 18px 18px 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  background: #faf8ff;
  box-shadow: 0 1px 2px rgba(127, 37, 251, 0.06);
`;

export const RewardBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 26px;
  padding: 0 10px;
  border-radius: 6px;
  background: #7f25fb;
  color: #fff;
  font-family: Pretendard;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const RewardCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ebe4ff;

  > .left {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
  }

  > button {
    flex-shrink: 0;
    height: 28px;
    padding: 0 10px;
    border: 1px solid #ff4d4f;
    border-radius: 6px;
    background: #fff;
    color: #ff4d4f;
    font-family: Pretendard;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
`;

export const RewardFieldRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 24px;
  flex-shrink: 0;
`;

export const CancelButton = styled.button`
  min-width: 88px;
  height: 44px;
  border: none;
  border-radius: 8px;
  background: #f0f0f0;
  color: #666;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;

export const SubmitButton = styled.button`
  min-width: 88px;
  height: 44px;
  border: none;
  border-radius: 8px;
  background: #7f25fb;
  color: #fff;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    background: #c4a0fd;
    cursor: not-allowed;
  }
`;

export const LoadingMessage = styled.div`
  padding: 60px 0;
  text-align: center;
  color: #969696;
  font-family: Pretendard;
  font-size: 14px;
`;

export const DisabledNotice = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 8px;
  background: #fff1f0;
  color: #cf1322;
  font-family: Pretendard;
  font-size: 13px;
  font-weight: 500;

  > .message {
    flex: 1;
    min-width: 0;
    word-break: keep-all;
  }
`;

export const ResetProgressButton = styled.button`
  flex-shrink: 0;
  height: 32px;
  padding: 0 12px;
  border: none;
  border-radius: 6px;
  background: #d91818;
  color: #fff;
  font-family: Pretendard;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
